import { api } from './api';

export const adminApi = {
  login: (credentials: any) => api.post('/api/auth/admin/signin', credentials),
  register: (credentials: any) => api.post('/admin/register', credentials),
  getUsers: (params: any) => api.get('/admin/users', { params, headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } }),
  createUser: (user: any) => api.post('/admin/users', user, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } }),
  updateUser: (id: number, user: any) => api.patch(`/admin/users/${id}`, user, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } }),
  deleteUser: (id: number) => api.delete(`/admin/users/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } }),
  getUserById: (id: number) => api.get(`/admin/users/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } }),
  getAllData: () => api.get('/api/all', { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } }),
};
